import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatRippleModule} from '@angular/material/core';
import {MatMenuModule} from '@angular/material/menu';
import {MatTreeModule} from '@angular/material/tree';
import {NbSecurityModule} from '@nebular/security';
import {NbActionsModule, NbAlertModule, NbBadgeModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbFormFieldModule, NbIconModule, NbInputModule, NbLayoutModule, NbProgressBarModule, NbRadioModule, NbSelectModule, NbSpinnerModule, NbTabsetModule, NbTagModule, NbToggleModule, NbTooltipModule} from '@nebular/theme';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyModule} from '@ngx-formly/core';
import {TableModule} from 'compob2b-table';
import {FileUploadModule} from 'ng2-file-upload';
import {NgxPaginationModule} from 'ngx-pagination';
import {BreadcrumbsModule} from '../../../../../compob2b-customer/src/app/cabinet/breadcrumbs/breadcrumbs.module';
import {BaseModule} from '../../../../../compob2b-table/lib/components/base/base.module';
import {AdminSharedModule} from '../../admin-shared/admin-shared.module';
import {CatalogModule} from '../pim/catalog/catalog.module';
import {CreateUpdateDamComponent} from './create-update/create-update-dam.component';
import {DamExternalUploadComponent} from './dam-external-upload/dam-external-upload.component';
import {DamCatalogLazyComponent} from './dam-lazy-tree/dam-catalog-lazy.component';
import {CreateUpdateDamPersonComponent} from './dam-person/create-update-dam-collections/create-update-dam-person.component';
import {DamPersonListComponent} from './dam-person/list/dam-person-list.component';
import {CreateUpdateDamRelatedCollectionComponent} from './dam-related-collections/create-update-dam-collections/create-update-dam-related-collecton.component';
import {DamRelatedCollectionListComponent} from './dam-related-collections/list/dam-related-collection-list.component';
import {DamRoutingModule} from './dam-routing.module';
import {DamSearchModalComponent} from './dam-search-modal/dam-search-modal.component';
import {DamShareComponent} from './dam-share/dam-share.component';
import {BasketTableLogListComponent} from './files/basket-table-log/list/basket-table-log-list.component';
import {BasketListComponent} from './files/basket/basket-list.component';
import {ShareDamItemVersionsComponent} from './files/share-dam-item-versions/share-dam-item-versions.component';
import {SecuredImageComponent} from './secured-image/secured-image.component';
import {YandexImportComponent} from './yandex-import/yandex-import.component';
import {DamFilesModule} from './files/dam-files.module'
import {ExternalUploadComponent} from './external-upload/external-upload.component'
import {ViewChangingTabsComponent} from './view-changing-tabs/view-changing-tabs.component'

@NgModule({
  declarations: [
    BasketListComponent,
    BasketTableLogListComponent,
    CreateUpdateDamComponent,
    CreateUpdateDamPersonComponent,
    CreateUpdateDamRelatedCollectionComponent,
    DamCatalogLazyComponent,
    DamExternalUploadComponent,
    DamPersonListComponent,
    DamRelatedCollectionListComponent,
    DamSearchModalComponent,
    DamShareComponent,
    ShareDamItemVersionsComponent,
    YandexImportComponent,
    ExternalUploadComponent,
  ],
  exports: [
    ShareDamItemVersionsComponent,
    ExternalUploadComponent,
  ],
  imports: [
    FormlyBootstrapModule,
    FormlyModule,
    FormsModule,
    AdminSharedModule,
    BaseModule,
    BreadcrumbsModule,
    CommonModule,
    DamRoutingModule,
    FileUploadModule,
    MatButtonModule,
    MatMenuModule,
    MatRippleModule,
    MatTreeModule,
    NbActionsModule,
    NbAlertModule,
    NbBadgeModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbFormFieldModule,
    NbIconModule,
    NbInputModule,
    NbProgressBarModule,
    NbRadioModule,
    NbSecurityModule,
    NbSelectModule,
    NbSpinnerModule,
    NbTabsetModule,
    NbTagModule,
    NbToggleModule,
    NbTooltipModule,
    NgSelectModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    TableModule,
    CdkDropList,
    CdkDrag,
    SecuredImageComponent,
    CatalogModule,
    DamFilesModule,
    ViewChangingTabsComponent,
    NbLayoutModule
  ]
})
export class DamModule {
}
